const routes = [
  {
    path: 'packaging-management',
    name: 'packagingManagement',
    component: () => import(/* webpackChunkName: "parameter-configuration" */ './views/PackagingManagement.vue'),
    meta: {
      // permissionRequired: true,
    },
  },
  {
    path: 'packaging-management-eb08',
    name: 'packagingManagementEb08',
    component: () => import(/* webpackChunkName: "parameter-configuration" */ './views/PackagingManagementEB08.vue'),
    meta: {
      // permissionRequired: true,
    },
  },
];

export default routes;
